import shcaSecKit from '../../static/lib/js/shcaSecKit';
import shcaUtils from '../../static/lib/js/shcaUtils';

export function CA() {
  var CAObj;
  var gSeCtl;
  var gSeCtlStr;
  var gServiceStr;
  var internettype;
  if (internettype = navigator.userAgent.indexOf('Firefox') > 0) {
    CAObj = document.getElementById('SafeEngineCtlNPAPI'); //调用NP接口方法
  } else if (internettype = navigator.userAgent.indexOf('Safari') > 0) {
    CAObj = document.getElementById('SafeEngineCtlNPAPI'); //调用NP接口方法
  } else if (internettype = navigator.userAgent.indexOf('Camino') > 0) {
    CAObj = document.getElementById('SafeEngineCtlNPAPI'); //调用NP接口方法
  } else if (internettype = navigator.userAgent.indexOf('Gecko/') > 0) {
    CAObj = document.getElementById('SafeEngineCtlNPAPI'); //调用NP接口方法
  } else if (internettype = navigator.userAgent.indexOf('Opera/') > 0) {
    CAObj = document.getElementById('SafeEngineCtlNPAPI'); //调用NP接口方法
  } else {
    CAObj = document.getElementById('SafeEngineCtlCOM');
  }

  CA.prototype.checkEnvironment = function() {//检查运行环境
    var agent = navigator.userAgent.toLowerCase();
    var isIE = agent.indexOf('compatible') > -1 && agent.indexOf('msie') > -1; //判断是否IE<11浏览器
    var isIE11 = agent.indexOf('trident') > -1 && agent.indexOf('rv:11.0') > -1;
    if ((isIE || isIE11) && CAObj) {
      var reIE = new RegExp('msie (\\d+\\.\\d+);');
      reIE.test(agent);
      var fIEVersion = parseFloat(RegExp['$1']);
      if (fIEVersion > 9 || isIE11) {
        return true;
      }
      return false;
    } else {
      return false;
    }
  };
  /**
   * 检测是否为法人一证通
   */
  CA.prototype.checkCert = function() {
    CAObj.SEH_InitialSession(2, '', '', 0, 2, '', '');
    var strCert = CAObj.SEH_GetSelfCertificate(10, 'com1', '');
    var isOne = CAObj.SEH_IsOneCertType(strCert);
    if ('1' != isOne) {
      CAObj.SEH_ClearSession();
      return false;
    }
    CAObj.SEH_ClearSession();
    return true;
  };
  CA.prototype.hadLock = function() {
    CAObj.SEH_InitialSession(2, '', '', 0, 2, '', '');
    var strCert1 = CAObj.SEH_GetSelfCertificate(10, 'com1', '');
    return strCert1;
  };
  CA.prototype.getCAInfo = function(password) {
    if (password === '') {
      throw new Error('请输入密码');
      return;
    }
    //初始化函数
    CAObj.SEH_InitialSession(10, 'com1', password, 0, 10, 'com1', '');
    if (CAObj.ErrorCode == -2113666992 || CAObj.ErrorCode == '-2113666992') {
      throw new Error('设备端口错误');
      CAObj.SEH_ClearSession();
      return;
    }
    if (CAObj.ErrorCode == -2113666989 || CAObj.ErrorCode == '-2113666989') {
      throw new Error('未检查到锁，请插入锁！');
      CAObj.SEH_ClearSession();
      return;
    }
    if (CAObj.ErrorCode == -2113666983 || CAObj.ErrorCode == '-2113666983') {
      throw new Error('设备无法识别');
      CAObj.SEH_ClearSession();
      return;
    }

    if (CAObj.ErrorCode === '-2113667065' || '-2113667017' ===
      CAObj.ErrorCode || '-2113667069' === CAObj.ErrorCode ||
      CAObj.ErrorCode === -2113667065 || -2113667017 === CAObj.ErrorCode ||
      -2113667069 === CAObj.ErrorCode) {
      throw new Error('您输入的密码不正确，请重新输入。');
      CAObj.SEH_ClearSession();
      return;
    }
    //获取证书内容
    var strCert = CAObj.SEH_GetSelfCertificate(10, 'com1', '');
    console.log(strCert);
    //var type=SafeEngineCtl.SEH_IsOneCertType(strCert);
    //if(type!=1){
    //	$("#CAconfirmText").html("请使用企业锁登陆系统!");
    //	$("#CAconfirmText").show();
    //	return;
    //}
    /*
       * SEH_IsOneCertType(strCert)
       *	该方法是用于区分证书是否是法人一证通证书或是非法人一证通证书。
       *	如返回值为1，表示该证书是法人一证通证书。则SafeEngineCtl.SEH_GetCertInfoByOID(strCert, "1.2.156.112570.11.205")则会返回该证书的唯一值。
       *	如返回值为0，表示该证书是非法人一证通证书。则不能使用SafeEngineCtl.SEH_GetCertInfoByOID(strCert, "1.2.156.112570.11.205")该方法。
       *	非法人一证通无OID "1.2.156.112570.11.205"的项。
       *	此时，你可以通过SafeEngineCtl.SEH_ GetCertUniqueID (strCert)该方法来获取非法人一证通证书的唯一值。
       *	如获取的值是JJ开头的，表示该证书是普通证书中的单位证书。JJ后面的信息为该单位的组织机构代码证号码。
       *	如获取的值是SF开头的，表示该证书是普通证书中的个人证书。SF后面的信息为该人的身份证号码。
       */
    var isOne = CAObj.SEH_IsOneCertType(strCert);
    if ('1' == isOne) {
      //获取UniqueId
      //strUniqueID = SafeEngineCtl.SEH_GetCertUniqueID(strCert);
      //取证书扩展项信息。唯一
      //cerOID= SafeEngineCtl.SEH_GetCertInfoByOID(strCert, "1.2.156.112570.11.205");

      var val = CAObj.SEH_GetCertInfoByOID(strCert, '1.2.156.112570.11.210'); //社会信用代码
      //取证书扩展项信息。唯一
      var cerOID = CAObj.SEH_GetCertInfoByOID(strCert, '1.2.156.112570.11.205');
      if (val == '' || val == null) {
        //获取UniqueId
        var strUniqueID = CAObj.SEH_GetCertUniqueID(strCert);
      } else {
        var sp = val.substring(val.length - 10, val.length);	//截取后十位
        var strUniqueID = sp.substring(0, 8) + '-' + sp.substring(8, 9);
      }
    } else {
      //获取UniqueId
      /*
        strUniqueID = SafeEngineCtl.SEH_GetCertUniqueID(strCert);
        var headStr = strUniqueID.substring(0,2);
        if(headStr == 'JJ'){//不能绑定普通证书中的单位证书
            return;
        }
        cerOID = strUniqueID;
        */
      throw new Error('请您使用企业证书注册');
      CAObj.SEH_ClearSession();
      return;
    }
    //证书级别
    var BeginDate = CAObj.SEH_GetCertDetail(strCert, 11);
    var EndDate = CAObj.SEH_GetCertDetail(strCert, 12);
    var certUniqueID;
    if ('1' == isOne) {
      certUniqueID = strUniqueID;//证书唯一标识
    }
    /*
      else{
          certUniqueID=strUniqueID.substring(2);
      }*/
    let cerlevel = CAObj.SEH_GetCertClass(strCert);
    let cerOverDate = CAObj.SEH_GetCertValidDate(strCert);//证书剩余天数;
    let cerVersion = CAObj.SEH_GetCertDetail(strCert, 1);//证书版本;
    let cerSerialNumber = CAObj.SEH_GetCertDetail(strCert, 2);//证书序列号;
    let cerAlgorithm = CAObj.SEH_GetCertDetail(strCert, 3);//证书签名算法;
    let cerGrantCountryName = CAObj.SEH_GetCertDetail(strCert, 4);//证书发放者国家名;
    let cerGrantOrganizeName = CAObj.SEH_GetCertDetail(strCert, 5);//证书发放者组织名;
    let cerGrantBranchName = CAObj.SEH_GetCertDetail(strCert, 6);//证书发放者部门名;
    let cerGrantProvinceName = CAObj.SEH_GetCertDetail(strCert, 7);//证书发放者省州名;
    let cerGrantUniversalName = CAObj.SEH_GetCertDetail(strCert, 8);//证书发放者通用名;
    let cerGrantCityName = CAObj.SEH_GetCertDetail(strCert, 9);//证书发放者城市名;
    let cerGrantEmail = CAObj.SEH_GetCertDetail(strCert, 10);//证书发放者Email;
    let cerCountryName = CAObj.SEH_GetCertDetail(strCert, 13);//用户国家名;
    let cerOrganizeName = CAObj.SEH_GetCertDetail(strCert, 14);//用户组织名;
    let cerBranchName = CAObj.SEH_GetCertDetail(strCert, 15);//用户部门名;
    let cerProvinceName = CAObj.SEH_GetCertDetail(strCert, 16);//用户省州名;
    let cerUniversalName = CAObj.SEH_GetCertDetail(strCert, 17);//用户通用名;
    let cerCityName = CAObj.SEH_GetCertDetail(strCert, 18);//用户城市名;
    let cerEmail = CAObj.SEH_GetCertDetail(strCert, 19);//用户Email;
    CAObj.SEH_ClearSession();
    let param = {};
    param['cerlevel'] = cerlevel;
    param['cerOverDate'] = cerOverDate;
    param['cerVersion'] = cerVersion;
    param['cerSerialNumber'] = cerSerialNumber;
    param['cerAlgorithm'] = cerAlgorithm;
    param['cerGrantCountryName'] = cerGrantCountryName;
    param['cerGrantOrganizeName'] = cerGrantOrganizeName;
    param['cerGrantBranchName'] = cerGrantBranchName;
    param['cerGrantProvinceName'] = cerGrantProvinceName;
    param['cerGrantUniversalName'] = cerGrantUniversalName;
    param['cerGrantCityName'] = cerGrantCityName;
    param['cerGrantEmail'] = cerGrantEmail;
    param['cerCountryName'] = cerCountryName;
    param['cerOrganizeName'] = cerOrganizeName;
    param['cerBranchName'] = cerBranchName;
    param['cerProvinceName'] = cerProvinceName;
    param['cerUniversalName'] = cerUniversalName;
    param['cerCityName'] = cerCityName;
    param['cerEmail'] = cerEmail;
    param['certUniqueID'] = certUniqueID;
    param['shxydm'] = val;
    param['cerBeginDate'] = BeginDate.substring(0, 4) + '-' +
      BeginDate.substring(4, 6) + '-' + BeginDate.substring(6, 8);
    param['cerEndDate'] = EndDate.substring(0, 4) + '-' +
      EndDate.substring(4, 6) + '-' + EndDate.substring(6, 8);
    param['cerOID'] = cerOID;
    param['cerContent'] = strCert;//证书内容;
    return param;
  };
  /**
   * 初始化
   * @returns {Promise<unknown>}
   */
  CA.prototype.initService = function() {
    return new Promise((resolve, reject) => {
      var K_SHCA_ASYMID_RSA = 1;
      var K_SHCA_USAGE_SIGN = 2;
      gSeCtl = shcaSecKit.getInstance( /*onSSKmessage*/);
      try {
        gSeCtl.initService({
          asymid: K_SHCA_ASYMID_RSA,
          usage: K_SHCA_USAGE_SIGN,
          res: function(data) {
            if (data.ret == 0) {
              gServiceStr = data.str;
              resolve(data.str);
            } else {
              reject('未检测到CA锁，请插入CA锁!');
            }
          },
        });
      } catch (e) {
        reject('未检测到CA锁，请插入CA锁!');
      }
    });
  };
  CA.prototype.getCertDetail = function(strCert, itemNo, oid) {
    let obj = {
      cert: strCert,
    };
    if (itemNo) {
      obj.itemNo = itemNo;
    }
    if (oid) {
      obj.oid = oid;
    }
    console.log('获取信息', obj);
    return new Promise((resolve, reject) => {
      obj.res = function(certValue) {
        if (certValue.ret == 0) { //cerVersion
          let value = shcaUtils.hex2str(
            b64tohex(certValue.str),
          ); //证书序列号
          resolve(value);
        } else {
          resolve();
        }
      };
      gSeCtl.getCertDetail(obj);
    });
  };
  /**
   * 获取锁信息
   */
  CA.prototype.getCertInfo = function(passwrod) {
    return new Promise((resolve, reject) => {
      var target_arr = eval('(' + gServiceStr + ')');
      if (target_arr.length > 0) {
        gSeCtl.setCryptoDevice(target_arr[0]);
        gSeCtl.getCert({
          res: (cert) => {
            if (cert.ret == 0) {
              gSeCtlStr = cert.str;
              console.info('锁内容：' + gSeCtlStr);
              this._getCertInfo(passwrod).then(res => {
                resolve(res);
              }).catch(e => {
                reject(e);
              });
            }
          },
        });
      } else {
        reject();
      }
    });
  };
  CA.prototype.getTYSHXYDM = function(strSigned) {
    let strCert = gSeCtlStr;
    return new Promise((resolve, reject) => {
      gSeCtl.getCertInfoByOID(
        {
          cert: strCert,
          oid: '1.2.156.112570.11.210',
          res: function(comid22) {
            if (comid22.ret == 0) {
              let deductCode = shcaUtils.hex2str(b64tohex(comid22.str)); //统一社会信用代码
              console.info('统一社会信用代码：' + deductCode);
              resolve(deductCode);
            } else {
              toAjax(
                '$!base/sj-register!getOrganCodeByCa.do',
                {
                  'cerSigned': strSigned,
                  'cerContent': strCert,
                },
                function(res) {
                  if (res.success) {
                    console.info(
                      '组织机构代码：' +
                      res.message);
                    resolve(res.message);
                  } else {
                    resolve();
                  }
                });
            }
          },
        });
    });

  };

  CA.prototype._getCertInfo = function(password) {
    let strCert = gSeCtlStr;
    return new Promise((resolve, reject) => {
      //数字签名
      var strRandom = '9818454326990764';
      gSeCtl.sign({
        data: strRandom,
        pwd: password,
        res: (signvalue) => {
          if (signvalue.ret == 2181300308) {
            reject('设备已锁，请拨打962600客服电话咨询');
            return;
          } else if (signvalue.ret == 0) {
            let strSigned = signvalue.str;
            gSeCtl.getCertInfoByOID({
              cert: strCert,
              oid: '1.2.156.112570.11.205',
              res: (comid1) => {
                if (comid1.ret == 0) {
                  let cerOid = shcaUtils.hex2str(
                    b64tohex(comid1.str)); //唯一标识码
                  console.info('唯一标识：' + cerOid);
                  let param = {};
                  param['cerOID'] = cerOid;
                  param['cerContent'] = strCert;
                  param['strSigned'] = strSigned;

                  /**
                   * 1 证书版本
                   * 2 证书序号
                   * 3 证书签名算法
                   * 4 证书发放者国家名
                   * 5 证书发放者组织名
                   * 6 证书发放者部门名
                   * 7 证书发放者省州名
                   * 8 证书发放者通用名
                   * 9 证书发放者城市名
                   * 10 证书发放者Email
                   * 11 开始时间
                   * 12 结束时间
                   * 13 用户国家名
                   * 14 用户组织名
                   * 15 用户部门名
                   * 16 用户省州名
                   * 17 用户通用名
                   * 18 用户城市名
                   * 1.2.156.112570.11.210 统一社会信用代码
                   */
                  this.getCertDetail(strCert, 17).then(res => {
                    param['cerUniversalName'] = res;
                    return this.getTYSHXYDM(strSigned);
                  }).then(res => {
                    param['shxydm'] = res;
                    return this.getCertDetail(strCert, 14);
                  }).then(res => {
                    param['cerOrganizeName'] = res;
                    resolve(param);
                  }).catch(error => {
                    reject('获取失败');
                  });

                  // Promise.all([
                  //   this.getCertDetail(strCert, 17),
                  //   this.getCertDetail(strCert, null, '1.2.156.112570.11.210'),
                  // ]).then(function(posts) {
                  //   param['cerUniversalName'] = posts[0];
                  //   param['shxydm'] = posts[1];
                  //   resolve(param);
                  // }).catch(function(reason) {
                  //   reject('获取失败');
                  // });
                }
              },
            });
          } else {
            console.error('锁信息获取失败，请联系管理员!');
            console.error(comid1);
            reject('锁信息获取失败，请联系管理员!');
          }
        },
      });
    });

  };

  CA.prototype.login_socket = function(strpassword) {
    var K_SHCA_ASYMID_RSA = 1;
    var K_SHCA_ASYMID_SM2 = 2;
    var K_SHCA_USAGE_SIGN = 2;
    var param = {};
    var cerVersion = '';
    var cerSerialNumber = '';
    var cerAlgorithm = '';
    var cerGrantCountryName = '';
    var cerGrantOrganizeName = '';
    var cerGrantBranchName = '';
    var cerGrantProvinceName = '';
    var cerGrantUniversalName = '';
    var cerGrantCityName = '';
    var cerGrantEmail = '';
    var BeginDate = '';
    var EndDate = '';
    var cerCountryName = '';
    var cerOrganizeName = '';
    var cerBranchName = '';
    var cerProvinceName = '';
    var cerUniversalName = '';
    var cerCityName = '';
    var cerEmail = '';
    var strCert = '';
    var cerOid = '';
    var deductCode = '';
    var strSigned = '';
    let gSeCtl = shcaSecKit.getInstance( /*onSSKmessage*/);
    try {
      gSeCtl.initService({
        asymid: K_SHCA_ASYMID_RSA,
        usage: K_SHCA_USAGE_SIGN,
        res: function(data) {
          if (data.ret == 0) {
            var target_arr = eval('(' + data.str + ')');
            if (target_arr.length > 0) {
              gSeCtl.setCryptoDevice(target_arr[0]);
              gSeCtl.getCert({
                res: function(cert) {
                  if (cert.ret == 0) {
                    strCert = cert.str;
                    console.info('锁内容：' + strCert);
                    gSeCtl.getCertDetail({
                      cert: strCert,
                      itemNo: 2,
                      res: function(certSn) {
                        if (certSn.ret == 0) {
                          //数字签名
                          var strRandom = '9818454326990764';
                          gSeCtl.sign({
                            data: strRandom,
                            pwd: strpassword,
                            res: function(signvalue) {
                              if (signvalue.ret == 2181300308) {
                                shcaUtils.alert({
                                  Text: '设备已锁，请拨打962600客服电话咨询',
                                });
                                $('#btnCALogin').removeAttr('disabled');
                                return;
                              }
                              if (signvalue.ret == 0) {
                                strSigned = signvalue.str;
                                gSeCtl.getCertInfoByOID({
                                  cert: strCert,
                                  oid: '1.2.156.112570.11.205',
                                  res: function(comid1) {
                                    if (comid1.ret == 0) {
                                      cerOid = shcaUtils.hex2str(
                                        b64tohex(comid1.str)); //唯一标识码
                                      console.info('唯一标识：' + cerOid);
                                      param['cerOID'] = cerOid;
                                      param['cerContent'] = strCert;
                                      param['strSigned'] = strSigned;
                                      gSeCtl.getCertDetail({
                                        cert: strCert,
                                        itemNo: 1,
                                        res: function(cerVersion) {
                                          if (cerVersion.ret == 0) { //cerVersion
                                            cerVersion = shcaUtils.hex2str(
                                              b64tohex(cerVersion.str)); //证书版本
                                            console.info('证书版本 ：' + cerVersion);
                                            gSeCtl.getCertDetail({
                                              cert: strCert,
                                              itemNo: 2,
                                              res: function(cerVersion1) {
                                                if (cerVersion1.ret == 0) { //cerVersion
                                                  cerSerialNumber = shcaUtils.hex2str(
                                                    b64tohex(cerVersion1.str)); //证书序列号
                                                  console.info('证书序列号 ：' +
                                                    cerSerialNumber);
                                                  gSeCtl.getCertDetail({
                                                    cert: strCert,
                                                    itemNo: 3,
                                                    res: function(cerVer) {
                                                      if (cerVer.ret == 0) { //cerVersion
                                                        cerAlgorithm = shcaUtils.hex2str(
                                                          b64tohex(cerVer.str)); //证书签名算法
                                                        console.info('证书签名算法：' +
                                                          cerAlgorithm);
                                                        gSeCtl.getCertDetail({
                                                          cert: strCert,
                                                          itemNo: 4,
                                                          res: function(cerVer3) {
                                                            if (cerVer3.ret ==
                                                              0) { //cerVersion
                                                              var cerGrantCountryName = shcaUtils.hex2str(
                                                                b64tohex(
                                                                  cerVer3.str)); //证书发放者国家名
                                                              console.info(
                                                                '证书发放者国家名：' +
                                                                cerGrantCountryName);
                                                              gSeCtl.getCertDetail(
                                                                {
                                                                  cert: strCert,
                                                                  itemNo: 5,
                                                                  res: function(cerVersion2) {
                                                                    if (cerVersion2.ret ==
                                                                      0) { //cerVersion
                                                                      cerGrantOrganizeName = shcaUtils.hex2str(
                                                                        b64tohex(
                                                                          cerVersion2.str)); //证书发放者组织名
                                                                      console.info(
                                                                        '证书发放者组织名：' +
                                                                        cerGrantOrganizeName);
                                                                      gSeCtl.getCertDetail(
                                                                        {
                                                                          cert: strCert,
                                                                          itemNo: 8,
                                                                          res: function(cerVersion3) {
                                                                            if (cerVersion3.ret ==
                                                                              0) { //cerVersion
                                                                              cerGrantUniversalName = shcaUtils.hex2str(
                                                                                b64tohex(
                                                                                  cerVersion3.str)); //证书发放者通用名
                                                                              console.info(
                                                                                '证书发放者通用名：' +
                                                                                cerGrantUniversalName);
                                                                              gSeCtl.getCertDetail(
                                                                                {
                                                                                  cert: strCert,
                                                                                  itemNo: 11,
                                                                                  res: function(cerVersion4) {
                                                                                    if (cerVersion4.ret ==
                                                                                      0) { //cerVersion
                                                                                      BeginDate = shcaUtils.hex2str(
                                                                                        b64tohex(
                                                                                          cerVersion4.str)); //开始时间
                                                                                      console.info(
                                                                                        '开始时间：' +
                                                                                        BeginDate);
                                                                                      gSeCtl.getCertDetail(
                                                                                        {
                                                                                          cert: strCert,
                                                                                          itemNo: 12,
                                                                                          res: function(cerVersion5) {
                                                                                            if (cerVersion5.ret ==
                                                                                              0) { //cerVersion
                                                                                              EndDate = shcaUtils.hex2str(
                                                                                                b64tohex(
                                                                                                  cerVersion5.str)); //结束时间
                                                                                              console.info(
                                                                                                '结束时间：' +
                                                                                                EndDate);
                                                                                              gSeCtl.getCertDetail(
                                                                                                {
                                                                                                  cert: strCert,
                                                                                                  itemNo: 13,
                                                                                                  res: function(cerVersion6) {
                                                                                                    if (cerVersion6.ret ==
                                                                                                      0) { //cerVersion
                                                                                                      cerCountryName = shcaUtils.hex2str(
                                                                                                        b64tohex(
                                                                                                          cerVersion6.str)); //用户国家名
                                                                                                      console.info(
                                                                                                        '用户国家名：' +
                                                                                                        cerCountryName);
                                                                                                      gSeCtl.getCertDetail(
                                                                                                        {
                                                                                                          cert: strCert,
                                                                                                          itemNo: 14,
                                                                                                          res: function(cerVersion7) {
                                                                                                            if (cerVersion7.ret ==
                                                                                                              0) { //cerVersion
                                                                                                              cerOrganizeName = shcaUtils.hex2str(
                                                                                                                b64tohex(
                                                                                                                  cerVersion7.str)); //用户组织名
                                                                                                              console.info(
                                                                                                                '用户组织名：' +
                                                                                                                cerOrganizeName);
                                                                                                              gSeCtl.getCertDetail(
                                                                                                                {
                                                                                                                  cert: strCert,
                                                                                                                  itemNo: 16,
                                                                                                                  res: function(cerVersion8) {
                                                                                                                    if (cerVersion8.ret ==
                                                                                                                      0) { //cerVersion
                                                                                                                      cerProvinceName = shcaUtils.hex2str(
                                                                                                                        b64tohex(
                                                                                                                          cerVersion8.str)); //用户省州名
                                                                                                                      console.info(
                                                                                                                        '用户省州名：' +
                                                                                                                        cerProvinceName);
                                                                                                                      gSeCtl.getCertDetail(
                                                                                                                        {
                                                                                                                          cert: strCert,
                                                                                                                          itemNo: 17,
                                                                                                                          res: function(cerVersion9) {
                                                                                                                            if (cerVersion9.ret ==
                                                                                                                              0) { //cerVersion
                                                                                                                              cerUniversalName = shcaUtils.hex2str(
                                                                                                                                b64tohex(
                                                                                                                                  cerVersion9.str)); //用户通用名
                                                                                                                              console.info(
                                                                                                                                '用户通用名：' +
                                                                                                                                cerUniversalName);
                                                                                                                              gSeCtl.getCertInfoByOID(
                                                                                                                                {
                                                                                                                                  cert: strCert,
                                                                                                                                  oid: '1.2.156.112570.11.210',
                                                                                                                                  res: function(comid22) {
                                                                                                                                    if (comid22.ret ==
                                                                                                                                      0) {
                                                                                                                                      deductCode = shcaUtils.hex2str(
                                                                                                                                        b64tohex(
                                                                                                                                          comid22.str)); //统一社会信用代码
                                                                                                                                      console.info(
                                                                                                                                        '统一社会信用代码：' +
                                                                                                                                        deductCode);
                                                                                                                                    } else {
                                                                                                                                      toAjax(
                                                                                                                                        '$!base/sj-register!getOrganCodeByCa.do',
                                                                                                                                        {
                                                                                                                                          'cerSigned': strSigned,
                                                                                                                                          'cerContent': strCert,
                                                                                                                                        },
                                                                                                                                        function(res) {
                                                                                                                                          if (res.success) {
                                                                                                                                            console.info(
                                                                                                                                              '组织机构代码：' +
                                                                                                                                              res.message);
                                                                                                                                          } else {
                                                                                                                                            shcaUtils.alert(
                                                                                                                                              {
                                                                                                                                                Text: res.message,
                                                                                                                                              });
                                                                                                                                          }
                                                                                                                                        });
                                                                                                                                    }
                                                                                                                                  },
                                                                                                                                });
                                                                                                                            }
                                                                                                                          },
                                                                                                                        });
                                                                                                                    }
                                                                                                                  },
                                                                                                                });
                                                                                                            }
                                                                                                          },
                                                                                                        });
                                                                                                    }
                                                                                                  },
                                                                                                });
                                                                                            }
                                                                                          },
                                                                                        });
                                                                                    }
                                                                                  },
                                                                                });
                                                                            }
                                                                          },
                                                                        });
                                                                    }
                                                                  },
                                                                });
                                                            }
                                                          },
                                                        });
                                                      }
                                                    },
                                                  });
                                                }
                                              },
                                            });
                                          }
                                        },
                                      });
                                    }
                                  },
                                });
                              } else {
                                $('#CAconfirmText').html('请确认密码是否正确!');
                                $('#CAconfirmText').show();
                                return;
                              }
                            },
                          });
                        }
                      },
                    });
                  }
                },
              });
            }
          } else {
            shcaUtils.alert({
              Text: '未检查到锁，请插入锁！',
            });
            return;
          }
        },
      });
    } catch (err) {
      console.error(err);
      shcaUtils.alert({
        Text: '请在本页面点击<a href=\'https://www.962600.com/resources/tools\'>\'驱动下载\'</a>安装最新协卡助手后重试!',
      });
      $('#btnCALogin').removeAttr('disabled');
      return;
    }

  };
}



// WEBPACK FOOTER //
// ./src/utils/cert.js